<template>
  <div class="login-page">
    <app-navbar></app-navbar>
    <div class="wrapper wrapper-full-page">
      <div class="full-page login-page section-image">
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-sm-6 col-md-5 col-lg-5 col-xs-12">
                <div class="contactInfo">
                  <h2>환영합니다.</h2>
                  <p>리테일미디어솔루션에 프로젝트를 의뢰하시거나 파트너십에 대해 궁금하신 점은 전화 혹은 메일로 문의해 주시기 바랍니다.</p>
                  <div class="media">
                    <span class="media-left">
                      <i class="fa fa-home" aria-hidden="true"></i>
                    </span>
                    <div class="media-body">
                      <h4 class="media-heading">본사</h4>
                      <p>04606 서울특별시 중구 동호로 20가길 49(장충동 1가)</p>
                    </div>
                  </div>
                  <div class="media">
                    <span class="media-left">
                      <i class="fa fa-phone" aria-hidden="true"></i>
                    </span>
                    <div class="media-body">
                      <h4 class="media-heading">전화번호</h4>
                      <p>02-2036-7700</p>
                    </div>
                  </div>
                  <div class="media">
                    <span class="media-left">
                      <i class="fa fa-fax" aria-hidden="true"></i>
                    </span>
                    <div class="media-body">
                      <h4 class="media-heading">팩스</h4>
                      <p>02-2036-7831~3</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-7 col-lg-7 col-xs-12">
                <div class="card">
                  <div class="card-header">
                    <h4 class="card-title">찾아오시는 길</h4>
                  </div>
                  <div class="card-body">
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.777898453989!2d127.00419635100967!3d37.56029623214376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357ca31a225fb9fd%3A0x64d2166d41681856!2s49%20Dongho-ro%2020ga-gil%2C%20Jangchung-dong%2C%20Jung-gu%2C%20Seoul!5e0!3m2!1sen!2skr!4v1574519744236!5m2!1sen!2skr" width="100%" height="320px" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
                  </div>
                </div>
              </div>
            </div>

            <div class="container space-2 space-3--lg">
              <div class="row">
                <div class="col-sm-6 col-md-3 mb-7 mb-md-0">
                  <h2 class="h4">광주지사</h2>
                  <hr class="my-5">
                  <address>
                    <!-- Contacts List -->
                    <ul class="list-unstyled">
                      <li class="media align-items-center pb-2">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div class="media-body" style="height: 56px;">
                          61937 광주광역시 서구 죽봉대로 61
                          이마트 광주점 5층, 광주신세계 통합사무실
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <div class="media-body">
                          062-360-1790
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-fax" aria-hidden="true"></i>
                        <div class="media-body">
                          062-360-1133
                        </div>
                      </li>
                    </ul>
                  </address>
                </div>

                <div class="col-sm-6 col-md-3 mb-7 mb-sm-0">
                  <h3 class="h4">부산지사</h3>
                  <hr class="my-5">
                  <address>
                    <ul class="list-unstyled">
                      <li class="media align-items-center pb-2">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div class="media-body" style="height: 56px;">
                          48058 부산광역시 해운대구 센텀남대로 35
                          신세계백화점 센텀시티 11층
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <div class="media-body">
                          051-745-1522
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-fax" aria-hidden="true"></i>
                        <div class="media-body">
                          051-745-1090
                        </div>
                      </li>
                    </ul>
                    <!-- End Contacts List -->
                  </address>
                </div>

                <div class="col-sm-6 col-md-3 mb-7 mb-sm-0">
                  <h3 class="h4">김해지사</h3>

                  <hr class="my-5">

                  <address>
                    <!-- Contacts List -->
                    <ul class="list-unstyled">
                      <li class="media align-items-center pb-2">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div class="media-body" style="height: 56px;">
                          50938 경남 김해시 김해대로 2232(외동)
                          신세계백화점 김해점 3층
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <div class="media-body">
                          055-272-1971
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-fax" aria-hidden="true"></i>
                        <div class="media-body">
                          055-272-1090
                        </div>
                      </li>
                    </ul>
                    <!-- End Contacts List -->
                  </address>
                </div>

                <div class="col-sm-6 col-md-3">
                  <h3 class="h4">대구지사</h3>

                  <hr class="my-5">

                  <address>
                    <!-- Contacts List -->
                    <ul class="list-unstyled">
                      <li class="media align-items-center pb-2">
                        <i class="fa fa-home" aria-hidden="true"></i>
                        <div class="media-body" style="height: 56px;">
                          41229 대구광역시 동구 동부로 149, 지하1층
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-phone" aria-hidden="true"></i>
                        <div class="media-body">
                          053-661-1280
                        </div>
                      </li>

                      <li class="media align-items-center py-2">
                        <i class="fa fa-fax" aria-hidden="true"></i>
                        <div class="media-body">
                          053-661-1088
                        </div>
                      </li>
                    </ul>
                    <!-- End Contacts List -->
                  </address>
                </div>
              </div>
            </div>
          </div>
        </div>
        <app-footer></app-footer>
        <div class="full-page-background"></div>
      </div>
    </div>
  </div>
</template>
<script>
    import {Card, Checkbox, Button} from 'src/components/UIComponents';
    import AppNavbar from './Layout/AppNavbar'
    import AppFooter from 'src/components/Pages/Views/Layout/AppFooter'
    import {API_KEY} from './API_KEY'
    import GoogleMapsLoader from 'google-maps'
    GoogleMapsLoader.KEY = API_KEY
    export default {
        components: {
            Card,
            AppNavbar,
            AppFooter,
            [Checkbox.name]: Checkbox,
            [Button.name]: Button
        },
        methods: {
            toggleNavbar() {
                document.body.classList.toggle('nav-open')
            },
            closeMenu() {
                document.body.classList.remove('nav-open')
                document.body.classList.remove('off-canvas-sidebar')
            },
            login() {
                // handle login here
            },
            initRegularMap (google) {
                // Regular Map
                const myLatlng = new window.google.maps.LatLng(37.560441, 127.006636)
                const mapOptions = {
                    zoom: 16,
                    center: myLatlng,
                    scrollwheel: false // we disable de scroll over the map, it is a really annoing when you scroll through page
                }

                const map = new window.google.maps.Map(document.getElementById('regularMap'), mapOptions)

                const marker = new window.google.maps.Marker({
                    position: myLatlng,
                    title: 'Regular Map!'
                })

                marker.setMap(map)
            }
        },
        data() {
            return {
                form: {
                    username: '',
                    password: ''
                }
            }
        },
        beforeDestroy() {
            this.closeMenu()
        },
        mounted () {
            GoogleMapsLoader.load((google) => {
                this.initRegularMap(google)
            })
        }
    }
</script>
<style scoped>
  .full-page-background {
    /*background-color: black;*/
    background-image: url(/static/img/background/lichterkette-4381663_1920.jpg);
    opacity: 0.7;
  }
  .login-page {
    color: white;
  }
  .contactInfo .media {
    margin-bottom: 20px;
  }

  .media-body {
    margin-left: 14px;
  }

  .media li i {
    margin-right: 14px;
  }

  .contactInfo .media .media-left {
    width: 75px;
    height: 75px;
    line-height: 75px;
    text-align: center;
    background-color: #ff891e;
    color: #ffffff;
    padding-right: 0;
    margin-right: 11px;
    font-size: 35px;
    float: left;
  }

  h4, .h4 {
    font-size: 1.714em;
    margin-top: 5px;
    margin-bottom: 0px;
    line-height: 1.1em;
  }

  .map {
    height: 320px;
  }

  .full-page > .content {
    padding-top: 11vh;
  }

  .full-page .footer {
    position: relative;
    width: 100%;
    bottom: 0;
  }

  hr {
    margin-top: 1rem;
    margin-bottom: 1rem;
    border: 0;
    border-top: 1px solid rgba(255, 255, 255, 0.5);
  }

  .mb-5, .my-5 {
    margin-bottom: 1rem !important;
    margin-top: 1rem !important;
  }
</style>
